<template>
    <div>
        <label :class="['label',  {'label--required': required}]" :for="name">
            <slot></slot>
        </label>
        <input
            class="input"
            :name="name"
            :id="name"
            :value="value"
            :type="inputType"
            :min="min"
            :step="step"
            :placeholder="placeholder"
            :disabled="disabled"
            :required="required"
            :class="[{'input--error': computedError}]"
            @input="$emit('input', $event.target.value)"
        />
        <span class="invalid-feedback" v-if="computedError">
            <strong>{{ computedError }}</strong>
        </span>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'value',
            event: 'input'
        },
        props: [
            'name',
            'error',
            'value',
            'required',
            'type',
            'min',
            'step',
            'placeholder',
            'disabled',
        ],
        computed: {
            inputType() {
                return this.type ? this.type : 'text'
            },
            computedError() {
                if (Array.isArray(this.error))  {
                    return this.error.reduce((prev,current)=> `${prev}, ${current}`)
                }
                return this.error || this.errors(this.name);
            }
        },
    }
</script>
